import axios from "axios";
import { User } from "../models/user";

class UserWebservice {
    
    /**
     * Call the login method on api
     *
     * @param username Email address
     * @param password Password
     */
    public login(email: string, password: string) {
        return axios.post("/auth/login", {
            grant_type: "password",
            email: email,
            password: password
        })
    }

    /** 
     * Fetch the current user info
     */
    public getUserInfo() {
        return axios.get("/userinfo");
    }
}

export const userWebservice = new UserWebservice();


// WEBPACK FOOTER //
// ./src/webservices/user.ts